export default {
	New: 6,
	None: 2,
	InProduction: 0,
	Produced: 1,
	InDispatch: 3,
	InDelivery: 4,
	Delivered: 5,
	Fakturiert: 8,
	Paid: 9,
	Storniert: 7,
	Unvollstaendig: 10,
	Abgeschlossen: 70,
	TerminUeberschritten: 90,
	Gestoert: 100,
};
